import _BossReport from "./BossReport";
import VuePlugin from "./VuePlugin";
export var BossReport = _BossReport;
VuePlugin.BossReport = _BossReport;
export default VuePlugin;